import { HttpErrorResponse } from '@angular/common/http';

import { FALLBACK_ERROR_MESSAGE } from '../constant/error-message.constant';

function toMessage(value: unknown): string | null {
    if (typeof value === 'string') {
        return value;
    }

    if (Array.isArray(value)) {
        return value.join('\n');
    }

    return null;
}

export function extractErrorMessage(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
        return (
            toMessage(error.error?.meta?.message) ??
            toMessage(error.error?.message) ??
            FALLBACK_ERROR_MESSAGE
        );
    }

    return FALLBACK_ERROR_MESSAGE;
}
